export default __webpack_public_path__ + "static/media/fast-car-with-done.3dc6a31e.svg";